exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".summary{width:100%}.summary .row{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;padding:20px 0}.summary .row .price,.summary .row .title{width:50%}.summary .row .price h5,.summary .row .title h5{margin:0;font-size:18px;line-height:28px}.summary .row .price{text-align:right}.summary .buttons .button{width:100%}.summary p.note{margin:10px 0 20px;font-size:12.5px;line-height:18px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-166feac5","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/frontend/js/modulatte-cart/components/Summary.vue
// module id = 04yu
// module chunks = 1